import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { OfficialProblemCategory } from '@/domain/entities/problem/officialProblemCategory'

export const officialProblemCategoryDecoder: Decoder<OfficialProblemCategory> = object({
  categoryId: string(),
  largeCl: string(),
  middleCl: string(),
  serial: number()
})
